import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import Vue from 'vue'
import { rtdbPlugin } from 'vuefire'
Vue.use(rtdbPlugin)

const firebaseConfig = {
  apiKey: "AIzaSyAOXCc-K83NhU7MqgJ9apYb24Ozc6NyEZ4",
  authDomain: "hato-projects.firebaseapp.com",
  databaseURL: "https://hato-projects.firebaseio.com",
  projectId: "hato-projects",
  storageBucket: "hato-projects.appspot.com",
  messagingSenderId: "240460213091",
  appId: "1:240460213091:web:71727536a406b26b"
};
// const project = 'private/together/'
const db = firebase
  .initializeApp(firebaseConfig)
  .database()

export {db, firebase}
